import React, {
	Component
} from 'react';
import styled from 'styled-components';
import { Button } from './UI';
import { store } from '../stores/mainStore';
import { ButtonBar } from './UI';
import { integration } from '../integration';
import { comm } from '../comm';


var config = window.dodConfig;

const ExitPage = styled.div`
	padding-top: ${p => config.isLandscape ? 0 : 25}%;
	box-sizing: border-box;
	width: 100%;
	height: 100%;
	background: rgba(0,0,0, 0.75);
	display: flex;
	justify-content: center;
	align-items: center;
	color: white;
	font-size: 32px;
	pointer-events: auto;
`

const Content = styled.div`
	display: flex;
	width: ${p => config.isLandscape ? 88 : 100}%;
	height: 100%;
	padding-top: 5%;
	box-sizing: border-box;
	background-size: 100% auto;
	text-align: center;
	flex-direction: column;
`

const CloseBox = styled.div`
	position: relative;
	display: inline-block;
	width: 90%;
	margin: 0 auto;
`

const BoxContent = styled.img`
	width: ${p => config.isLandscape ? 50 : 100}%;
`

export class ModalExit extends Component {

	cancel(){
		integration.postAnalyticsEvent(`cancel_exit`);
		store.modal = '';
	}

	exit = () => {
		integration.postAnalyticsEvent(`abandon_game`);
		if(store.tutorialMode){
			integration.onTutorialAborted();
			window.restartWebview();
		} else if(!this.pending) {
			this.pending = true;
			comm.AbandonMatch()
			.then(() => {
				window.restartWebview();
				// manager.cup.hideCup();
				// store.state = 'bet';
				// store.modal = '';
			})
			.catch(() => {
				this.pending = false;
			});
		}
	}

	render() {
		return (
			<ExitPage>
				<Content>
					<CloseBox>
						<BoxContent src={`/assets/${store.tutorialMode ? 'exit_game_tutorial' : 'exit_message'}.png`}/>
					</CloseBox>
					<ButtonBar>
						<Button cancel onClick={this.cancel}/>
						<Button exit onClick={this.exit}/>
					</ButtonBar>
				</Content>
			</ExitPage>
		);
	}
}
